import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, DataService, CalculationService, ValidationService, DateService } from 'app/services';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-delete-category-enhanced-dialog',
  templateUrl: './delete-category-enhanced-dialog.component.html',
  styleUrls: ['./delete-category-enhanced-dialog.component.scss'],
})
export class DeleteCategoryEnhancedDialogComponent implements OnInit {
  categoryName: string = '';
  associatedCategoryCount: number = 0;
  categoryLevelResults: any[] = [];
  selectedCategoryLevel: any = {};
  loader = {
    isDeleting: false,
    isLoading: false,
  };
  option = {
    codeId: '',
    itemType: '',
    categoryLevel: '',
    category: { categoryId: '', categoryName: '' },
    subCategory: { subCategoryId: '', subCategoryName: '' },
    subSubCategory: { subSubCategoryId: '', subSubCategoryName: '' },
  };
  deleteType: string = 'delete';
  deleteCategoryOption = [
    {
      id: 1,
      name: 'Delete this category',
      field: 'delete',
      text: 'All associated items with this category will be updated to clear their category and marked as unassigned (to category)',
    },
    {
      id: 2,
      name: 'Replace and Delete',
      field: 'replaceAndDelete',
      text: 'Select a new category to move the associated items to and then delete the category.',
    },
  ];

  constructor(private helperService: HelperService, private httpService: HTTPService, private dynamicDialogRef: DynamicDialogRef, private dConfig: DynamicDialogConfig) {}

  ngOnInit() {
    const { codeId, itemType, categoryLevel, category, subCategory, subSubCategory } = this.dConfig.data;

    this.option = {
      codeId,
      itemType,
      categoryLevel,
      category,
      subCategory,
      subSubCategory,
    };
    this.getCategoryLevel();
  }

  ngOnDestroy(): void {}

  async getCategoryLevel() {
    try {
      this.loader.isLoading = true;
      const query = {
        itemType: this.option.itemType,
        categoryLevel: this.option.categoryLevel,
        codeId: this.option.codeId,
      };
      const { name, count, results }: any = await this.httpService.getCategoryLevel(query);

      this.categoryName = name;
      this.categoryLevelResults = results;
      this.associatedCategoryCount = count;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.isLoading = false;
    }
  }

  handleSelect(type: string, value: any) {
    if (type === 'deleteType') this.deleteType = value;
    else if (type === 'replaceCategory') this.selectedCategoryLevel = value;
  }

  handleDialogClose(isSuccess: boolean = false, data: any = {}) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }

  async handleSubmit() {
    if (this.loader.isDeleting) return;
    this.loader.isDeleting = true;
    try {
      if (this.deleteType === 'delete') {
        await this.httpService.deleteCategoryById(this.option.codeId);
      } else if (this.deleteType === 'replaceAndDelete') {
        await this.httpService.deleteCategoryById(this.option.codeId, this.selectedCategoryLevel?._id);
      }

      this.handleDialogClose(true);
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.isDeleting = false;
    }
  }
}
